import { render } from "./CustomerCase.vue?vue&type=template&id=3a1a242b&scoped=true"
import script from "./CustomerCase.vue?vue&type=script&lang=js"
export * from "./CustomerCase.vue?vue&type=script&lang=js"

import "./CustomerCase.vue?vue&type=style&index=0&id=3a1a242b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1a242b"]])

export default __exports__